// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1cf465a2","453":"919ebfe8","455":"6af809b4"}[chunkId] + ".chunk.js";
};